












































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ConfirmButton from '@/components/ConfirmButton.vue';
import {Getter, Mutation} from 'vuex-class';
import {Organisation} from '@/types';
import {RouterHelper} from '@/router';
@Component({
  components: {ConfirmButton},
})
export default class OrganisationSelect extends Vue {
  @Prop() private isMobileMenu: any;
  @Getter private organisations: any;
  @Getter private activeOrganisation: any;
  @Getter private hasPermission: any;
  @Getter private showAllOrganisations: any;
  private foundOrgs: Organisation[] = [];
  private search: string = '';
  private selectedOrganisation: any = {};
  private focused: boolean = false;

  @Watch('activeOrganisation', {deep: true})
  private onOrgChange() {
    this.selectedOrganisation = this.activeOrganisation[0];
  }

  private get sortedOrganisations() {
    const sortByName = (a: { id: number, name: string }, b: { id: number, name: string }) => {
      return a.name.localeCompare(b.name);
    };
    return this.organisations.organisations.slice().sort(sortByName);

  }

  private mounted() {
    this.selectedOrganisation = this.activeOrganisation[0];
    this.foundOrgs.push(this.activeOrganisation[0]);
  }

  private searchOrganisations() {
    const search = this.search.length ? this.search.toString().toLowerCase() : null;
    if (this.organisations.organisations.length && search) {
      Vue.set(this, 'foundOrgs', this.organisations.organisations.filter((i: Organisation) => i.name.toLowerCase().includes(search)));
    }
  }

  private async onSelectedOrganisationChanged(id: string, event: any) {
    await RouterHelper.switchOrganisation(Number(id));
  }


}
